import { apiService } from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';

export interface Patient {
  id: number;
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone_number: string;
  username: string;
  date_of_birth: string;
  gender: string;
  address: string;
  avatarUrl: string | null;
  rmrKcalDay: number;
  weight: number;
}

export const patientsService = {
  getPatients: async (): Promise<Patient[]> => {
    const url = `${API_BASE_URL}/clinic/patient/`
    try {
      const response = await apiService.get(url);
      return response.results;
    } catch (error) {
      console.error('Error fetching patients:', error);
      throw error;
    }
  },

  getPatientById: async (id: string | number): Promise<Patient> => {
    const url = `${API_BASE_URL}/clinic/patient/${id}/`;
    try {
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error(`Error fetching patient with id ${id}:`, error);
      throw error;
    }
  },
}; 